import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { apiUrl } from "../../utils/variables";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";

const LastSavedFile = () => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    const getLastDocument = async () => {
      const resp = await fetch(`${apiUrl}/documents/last`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const { id } = await resp.json();
      if (id) {
        navigate(`/file/${id}`);
      } else {
        navigate("/");
        Swal.fire(
          "Error!",
          "No file created yet. Please start with a blank page first to continue.",
          "error"
        );
      }
    };
    getLastDocument();
  }, [token]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default LastSavedFile;
